export const truncateText = (text = "", max = 20, min = 7) => {
  if (text.length <= max) return text;
  return text.slice(0, Math.max(min, max)) + "...";
};
